<template>
  <div>
    <div class="vx-row flex flex-col">
      <div class="vx-col w-full">
        <vs-card>
          <div slot="header">
            <h3>Tambah Counter</h3>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <v-select
                placeholder="Counter Layanan"
                :options="counter"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="selectedCounter"
              />
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-row w-full">
              <div class="flex flex-row">
                <vs-button
                  @click="saveData"
                  class="ml-8 w-1/2"
                  color="primary"
                  icon-pack="feather"
                  icon="icon-send"
                  type="filled"
                >Simpan</vs-button>
                <vs-button
                  @click="$router.push({name: 'devices-detail', params : {id : $route.params.id}})"
                  class="ml-3 w-1/2"
                  color="primary"
                  icon-pack="feather"
                  icon="icon-arrow-left"
                  type="border"
                >Kembali</vs-button>
              </div>
            </div>
          </div>
        </vs-card>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";

export default {
  data() {
    return {
      selectedCounter : null,
      counter: []
    };
  },
  mounted() {
    this.getCounter();
  },
  methods: {
    getCounter() {
      this.$vs.loading();
      this.$http
        .get(`/app/secure/devices/counter`)
        .then(r => {
          this.counter = r.data.data.counter;
        })
        .catch(e => {
          this.parseError(e);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    saveData() {
      this.$vs.loading();
      this.$http
        .post(`/app/secure/devices/store-group-devices`, {
          groupable_id : this.selectedCounter ? this.selectedCounter.id : null,
          device_id : this.$route.params.id
        })
        .then(() => {
          this.$vs.notify({
            title: "Sukses",
            text: "Berhasil menyimpan data loket layanan.",
            color: "success",
            position: "top-right"
          });
          this.$router.push({name: 'devices-detail', params : {id : this.$route.params.id}})
        })
        .catch(e => {
            this.parseError(e);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
  },
  components: {
    "v-select": vSelect
  }
};
</script>